// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { AsgardeoAuthException } from "@asgardeo/auth-react";
import { FunctionComponent, ReactElement } from "react";
import { AuthenticationFailure } from "../pages/error-handling/AuthenticationFailure";
import { InvalidSystemTimePage } from "../pages/error-handling/InvalidSystemTime";

interface ErrorBoundaryProps {
  error: AsgardeoAuthException;
  children: ReactElement;
}

export const AsgErrorBoundary: FunctionComponent<ErrorBoundaryProps> = (
  props: ErrorBoundaryProps
): ReactElement => {
  const { error, children } = props;

  if (error?.code === "JS-CRYPTO_UTILS-IVIT-IV02") {
    return <InvalidSystemTimePage />;
  } else if (error?.code === "SPA-MAIN_THREAD_CLIENT-SI-SE01") {
    return <AuthenticationFailure />;
  }

  return children;
};
